import styles from '../../css/InfoBreakfast.module.css'
import CarouselDefault from "../UI/Carousel";
import {InfoBreakfastGallery} from '../../media/images/gallery/colazioni/InfoBreakfast';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';


const InfoBreakfast = () => {
    const { t } = useTranslation("global")
    return <>
        <div className={styles.container}>
            <div className={styles.textContainer}>
                <h2 className={styles.title}>{t("infoBreakfast.title")}</h2>
                <p className={styles.text}>{t("infoBreakfast.text")}</p>
                <h2 className={styles.title}>{t("infoBreakfast.titleItalian")}</h2>
                <p className={styles.text}>{t("infoBreakfast.italian")}</p>
                <h2 className={styles.title}>{t("infoBreakfast.titleContinental")}</h2>
                <p className={styles.text}>{t("infoBreakfast.continental")}</p>
                <h2 className={styles.title}>{t("infoBreakfast.titleVegetarian")}</h2>
                <p className={styles.text}>{t("infoBreakfast.vegetarian")}</p>
                <p>{t("infoBreakfast.extra")} <Link to="/booking">form</Link></p>
            </div>
            <CarouselDefault gallery={InfoBreakfastGallery} />
        </div>
    </>
}

export default InfoBreakfast;